module.exports = __webpack_public_path__ + "static/media/application-logo--inverse.f45b292f.svg";